import { useState, useEffect, useReducer } from 'react'
import { Route, useParams, Switch } from 'react-router-dom'

import PackageUnitInventoryTransfer from '../PackageUnitInventoryTransfer'
import PackageUnitPurchase from '../PackageUnitPurchase'
import PackageUnitInventoryCalibration from '../PackageUnitInventoryCalibration'
import Table from './Table'

import reducer, { initialState } from './state'

const MODULE_PATH = '/operations/:zone+/inventory/packaging'

function PackageUnitInventory() {
  const params = useParams()

  const [state, dispatchState] = useReducer(reducer, initialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  return (
    <Switch>
      <Route path={`${MODULE_PATH}/transfers`}>
        <PackageUnitInventoryTransfer
          organizationId={state.organizationId}
          storageFacilityId={state.storageFacilityId}
          packageUnitId={state.packageUnitId}
          backPath={modulePath}
        />
      </Route>
      <Route path={`${MODULE_PATH}/purchases`}>
        <PackageUnitPurchase
          organizationId={state.organizationId}
          storageFacilityId={state.storageFacilityId}
          packageUnitId={state.packageUnitId}
          backPath={modulePath}
        />
      </Route>
      <Route path={`${MODULE_PATH}/calibration`}>
        <PackageUnitInventoryCalibration
          packageUnitInventoryId={state.packageUnitInventoryId}
          backPath={modulePath}
        />
      </Route>
      <Route path={MODULE_PATH} exact={true}>
        <Table
          state={state}
          dispatchState={dispatchState}
          modulePath={modulePath}
        />
      </Route>
    </Switch>
  )
}

export default PackageUnitInventory
